import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { BaseManufacturingOrderBuilder } from '../../models/builders/base-manufacturing-order.builder';

@Injectable()
export class BaseManufacturingOrderApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }base-manufacturing-orders`;
  }

  getBaseManufacturingOrders() {
    return this.httpClient.get(`${ this.apiUrl }`)
      .pipe(
        map(BaseManufacturingOrderBuilder.fromList)
      );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/base-manufacturing-order-api.service.ts